module.exports = __webpack_public_path__ + "media/components/guide-page/static/best-surf-background-f559bf31e7f463c0a3fc4a830c521af7.jpg";